import { NotificationPreferenceService } from '../notification-preference.service';
import { UpdateNotificationPreferenceDto } from '../../../shared/model/update-notification-preference-dto.model';
import { ActivatedRoute } from "@angular/router";
import { of } from "rxjs";
import { AccountService } from '../../../core/auth/account.service';
import { JhiLanguageService } from '../../../ng-jhipster/language';
import * as i0 from "@angular/core";
import * as i1 from "../notification-preference.service";
import * as i2 from "@angular/router";
import * as i3 from "../../../core/auth/account.service";
import * as i4 from "../../../ng-jhipster/language";
import * as i5 from "../../../shared/unauth-header/unauth-header.component";
import * as i6 from "@angular/common";
import * as i7 from "../../../ng-jhipster/language/jhi-translate.directive";
import * as i8 from "@angular/material/radio";
import * as i9 from "@angular/forms";
import * as i10 from "@ngx-translate/core";
function UnsubscribeEmailComponent_div_2_div_3_ng_container_17_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 23);
    i0.ɵɵelementStart(2, "textarea", 24);
    i0.ɵɵlistener("ngModelChange", function UnsubscribeEmailComponent_div_2_div_3_ng_container_17_Template_textarea_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(3); return ctx_r4.otherReason = $event; });
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵtext(4, "                ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(3, 2, "inukaNgApp.notificationPreference.unsubscribeEmail.otherReasonTextBoxPlaceHolder"));
    i0.ɵɵproperty("ngModel", ctx_r3.otherReason);
} }
function UnsubscribeEmailComponent_div_2_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelementStart(1, "h3");
    i0.ɵɵelement(2, "span", 8);
    i0.ɵɵtext(3, "\u00A0");
    i0.ɵɵelement(4, "span", 9);
    i0.ɵɵtext(5, "\u00A0");
    i0.ɵɵelement(6, "span", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "p", 11);
    i0.ɵɵelementStart(8, "div", 12);
    i0.ɵɵelementStart(9, "div", 13);
    i0.ɵɵelementStart(10, "mat-radio-group", 14);
    i0.ɵɵlistener("ngModelChange", function UnsubscribeEmailComponent_div_2_div_3_Template_mat_radio_group_ngModelChange_10_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(2); return ctx_r6.reason = $event; });
    i0.ɵɵelementStart(11, "mat-radio-button", 15);
    i0.ɵɵlistener("change", function UnsubscribeEmailComponent_div_2_div_3_Template_mat_radio_button_change_11_listener() { i0.ɵɵrestoreView(_r7); const ctx_r8 = i0.ɵɵnextContext(2); return ctx_r8.reason = "TOO_MANY_EMAIL_ABOUT_THIS_TOPIC"; });
    i0.ɵɵelement(12, "span", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "mat-radio-button", 15);
    i0.ɵɵlistener("change", function UnsubscribeEmailComponent_div_2_div_3_Template_mat_radio_button_change_13_listener() { i0.ɵɵrestoreView(_r7); const ctx_r9 = i0.ɵɵnextContext(2); return ctx_r9.reason = "NOT_USEFUL"; });
    i0.ɵɵelement(14, "span", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "mat-radio-button", 15);
    i0.ɵɵlistener("change", function UnsubscribeEmailComponent_div_2_div_3_Template_mat_radio_button_change_15_listener() { i0.ɵɵrestoreView(_r7); const ctx_r10 = i0.ɵɵnextContext(2); return ctx_r10.reason = "OTHER"; });
    i0.ɵɵelement(16, "span", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(17, UnsubscribeEmailComponent_div_2_div_3_ng_container_17_Template, 5, 4, "ng-container", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 20);
    i0.ɵɵelementStart(19, "div", 21);
    i0.ɵɵelementStart(20, "button", 22);
    i0.ɵɵlistener("click", function UnsubscribeEmailComponent_div_2_div_3_Template_button_click_20_listener() { i0.ɵɵrestoreView(_r7); const ctx_r11 = i0.ɵɵnextContext(2); return ctx_r11.submit(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("jhiTranslate", "inukaNgApp.notificationPreference.notificationGroups." + ctx_r1.notificationGroup);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngModel", ctx_r1.reason);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", "TOO_MANY_EMAIL_ABOUT_THIS_TOPIC");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", "NOT_USEFUL");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", "OTHER");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.reason === "OTHER");
} }
function UnsubscribeEmailComponent_div_2_div_4_a_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "a", 31);
} }
function UnsubscribeEmailComponent_div_2_div_4_a_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "a", 32);
} }
function UnsubscribeEmailComponent_div_2_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵelementStart(1, "h3");
    i0.ɵɵelement(2, "span", 26);
    i0.ɵɵtext(3, "\u00A0");
    i0.ɵɵelement(4, "span", 9);
    i0.ɵɵtext(5, "\u00A0");
    i0.ɵɵelement(6, "span", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 28);
    i0.ɵɵtemplate(8, UnsubscribeEmailComponent_div_2_div_4_a_8_Template, 1, 0, "a", 29);
    i0.ɵɵtemplate(9, UnsubscribeEmailComponent_div_2_div_4_a_9_Template, 1, 0, "a", 30);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("jhiTranslate", "inukaNgApp.notificationPreference.notificationGroups." + ctx_r2.notificationGroup);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r2.isAuthenticated);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.isAuthenticated);
} }
function UnsubscribeEmailComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵelementStart(2, "div", 4);
    i0.ɵɵtemplate(3, UnsubscribeEmailComponent_div_2_div_3_Template, 21, 6, "div", 5);
    i0.ɵɵtemplate(4, UnsubscribeEmailComponent_div_2_div_4_Template, 10, 3, "div", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r0.submitted);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.submitted);
} }
export class UnsubscribeEmailComponent {
    constructor(notificationPreferenceService, activatedRoute, accountService, languageService) {
        this.notificationPreferenceService = notificationPreferenceService;
        this.activatedRoute = activatedRoute;
        this.accountService = accountService;
        this.languageService = languageService;
    }
    ngOnInit() {
        const publicId = this.activatedRoute.snapshot.queryParamMap.get(UnsubscribeEmailComponent.PUBLIC_ID_PARAMETER_NAME);
        const notificationGroup = this.activatedRoute.snapshot.queryParamMap.get(UnsubscribeEmailComponent.NOTIFICATION_GROUP_PARAMETER_NAME);
        const langKey = this.activatedRoute.snapshot.queryParamMap.get(UnsubscribeEmailComponent.LANG_KEY_PARAMETER_NAME);
        if (publicId && notificationGroup) {
            this.publicId = publicId;
            this.notificationGroup = notificationGroup;
            this.updateEmailNotificationPreference().subscribe(() => { }, (error) => { }, () => {
                UnsubscribeEmailComponent.isSubmitRequestInProgress = false;
            });
        }
        if (langKey) {
            this.languageService.changeLanguage(langKey);
        }
        this.isAuthenticated = this.accountService.isAuthenticated();
    }
    updateEmailNotificationPreference() {
        if (UnsubscribeEmailComponent.isSubmitRequestInProgress) {
            return of();
        }
        else {
            UnsubscribeEmailComponent.isSubmitRequestInProgress = true;
        }
        let reasonOfDisabling = this.reason;
        if (this.reason === 'OTHER') {
            reasonOfDisabling = this.otherReason;
        }
        const updateNotificationPreferenceDto = new UpdateNotificationPreferenceDto(this.notificationGroup, 'EMAIL', false, reasonOfDisabling);
        return this.notificationPreferenceService.updateEmailNotificationPreference(this.publicId, updateNotificationPreferenceDto);
    }
    submit() {
        this.updateEmailNotificationPreference().subscribe(() => {
            this.submitted = true;
        }, (error) => { }, () => {
            UnsubscribeEmailComponent.isSubmitRequestInProgress = false;
        });
    }
}
UnsubscribeEmailComponent.PUBLIC_ID_PARAMETER_NAME = 'publicId';
UnsubscribeEmailComponent.NOTIFICATION_GROUP_PARAMETER_NAME = 'group';
UnsubscribeEmailComponent.LANG_KEY_PARAMETER_NAME = 'langKey';
UnsubscribeEmailComponent.ɵfac = function UnsubscribeEmailComponent_Factory(t) { return new (t || UnsubscribeEmailComponent)(i0.ɵɵdirectiveInject(i1.NotificationPreferenceService), i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i3.AccountService), i0.ɵɵdirectiveInject(i4.JhiLanguageService)); };
UnsubscribeEmailComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: UnsubscribeEmailComponent, selectors: [["unsubscribe-email"]], decls: 3, vars: 1, consts: [[1, "olha-theme"], ["class", "container bg-2", "style", "margin-top: 60px", 4, "ngIf"], [1, "container", "bg-2", 2, "margin-top", "60px"], [1, "d-flex", "justify-content-center"], [1, "card", "py-4", "px-5", "mt-5"], ["class", "text-left", 4, "ngIf"], ["class", "text-center", 4, "ngIf"], [1, "text-left"], ["jhiTranslate", "inukaNgApp.notificationPreference.unsubscribeEmail.header"], [3, "jhiTranslate"], ["jhiTranslate", "inukaNgApp.notificationPreference.unsubscribeEmail.headerEnd"], ["jhiTranslate", "inukaNgApp.notificationPreference.unsubscribeEmail.subHeader", 1, "text-muted"], [1, "row", "mb-2"], [1, "col", "text-left"], [3, "ngModel", "ngModelChange"], [1, "check-box", 3, "value", "change"], ["jhiTranslate", "inukaNgApp.notificationPreference.unsubscribeEmail.reasons.TOO_MANY_EMAIL_ABOUT_THIS_TOPIC"], ["jhiTranslate", "inukaNgApp.notificationPreference.unsubscribeEmail.reasons.NOT_USEFUL"], ["jhiTranslate", "inukaNgApp.notificationPreference.unsubscribeEmail.reasons.OTHER"], [4, "ngIf"], [1, "row"], [1, "col", "text-center"], ["jhiTranslate", "inukaNgApp.notificationPreference.submit", "id", "index-get-started-btn", 1, "btn", "btn-primary", 3, "click"], [1, "form-group", "pl-4"], ["rows", "3", "maxlength", "255", "name", "other", 1, "mt-2", "p-2", "form-control", 2, "border", "1px solid #8A9D98", 3, "ngModel", "placeholder", "ngModelChange"], [1, "text-center"], ["jhiTranslate", "inukaNgApp.notificationPreference.unsubscribeEmail.headerSubmitted"], ["jhiTranslate", "inukaNgApp.notificationPreference.unsubscribeEmail.headerSubmittedEnd"], [1, "mt-5"], ["class", "btn btn-primary", "routerLink", "/login", "jhiTranslate", "login.form.logIn", 4, "ngIf"], ["class", "btn btn-primary", "routerLink", "/", "jhiTranslate", "global.menu.home", 4, "ngIf"], ["routerLink", "/login", "jhiTranslate", "login.form.logIn", 1, "btn", "btn-primary"], ["routerLink", "/", "jhiTranslate", "global.menu.home", 1, "btn", "btn-primary"]], template: function UnsubscribeEmailComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "unauth-header");
        i0.ɵɵelementStart(1, "div", 0);
        i0.ɵɵtemplate(2, UnsubscribeEmailComponent_div_2_Template, 5, 2, "div", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.notificationGroup);
    } }, directives: [i5.UnauthHeaderComponent, i6.NgIf, i7.JhiTranslateDirective, i8.MatRadioGroup, i9.NgControlStatus, i9.NgModel, i8.MatRadioButton, i9.DefaultValueAccessor, i9.MaxLengthValidator, i2.RouterLinkWithHref], pipes: [i10.TranslatePipe], styles: [".check-box[_ngcontent-%COMP%]{display:block;margin-top:8px}.card[_ngcontent-%COMP%]{width:100%;height:auto}@media(min-width: 768px){.card[_ngcontent-%COMP%]{width:50%;height:auto}}@media(min-width: 992px){.card[_ngcontent-%COMP%]{width:40%;height:auto}}"] });
